import React from "react";
import ReactPaginate from "react-paginate";
import { NextArrow, PrevArrow } from "./ProjectIcons";
import { useTranslation } from "react-i18next";

type PaginationProps = {
  showText: boolean;
  handlePageClick: Function;
  pageCount: number;
  resultStart: number;
  resultEnd: number;
  totalCount: number;
  take: number;
  loading: boolean;
  mainclassname: string;
  initialPage?: number;
  pageSize?: number;
  pageSizeOptions?: number[];
  onPageSizeChange?: (size: number) => void;
};

const Pagination = ({
  showText,
  handlePageClick,
  pageCount,
  resultStart,
  resultEnd,
  totalCount,
  take,
  loading,
  mainclassname,
  initialPage = 0,
  pageSize,
  pageSizeOptions,
  onPageSizeChange,
}: PaginationProps) => {
  const { t } = useTranslation();
  const showPageSizePicker =
    pageSize !== undefined &&
    pageSizeOptions !== undefined &&
    onPageSizeChange !== undefined;

  return (
    <div className={mainclassname}>
      <div className="flex flex-row items-center gap-4">
        {showText ? (
          <div>
            {totalCount > 0 &&
              (loading ? (
                <span className="text-primary-off-black dark:text-primary-off-white py-2 transition duration-300">
                  {t("Loading...")}
                </span>
              ) : (
                <span className="text-primary-off-black dark:text-primary-off-white py-2 transition duration-300">
                  {t("Showing")} {resultStart} {t("to")} {resultEnd} {t("of")}{" "}
                  {totalCount}
                </span>
              ))}
          </div>
        ) : null}
        {showPageSizePicker && (
          <div className="flex items-center gap-2 text-primary-off-black dark:text-primary-off-white">
            <span>{t("Rows per page:")}</span>
            <select
              value={pageSize}
              onChange={(e) => onPageSizeChange!(Number(e.target.value))}
              aria-label={t("Rows per page:")}
              className="rounded border border-storm-blue-light bg-off-white-dark dark:bg-storm-blue dark:border-storm-blue-light text-off-black-light dark:text-off-white-dark text-sm px-2 py-1"
            >
              {pageSizeOptions!.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
      <ReactPaginate
        previousLabel={totalCount > take ? <PrevArrow /> : null}
        nextLabel={totalCount > take ? <NextArrow /> : null}
        breakLabel={". . ."}
        pageCount={Math.max(1, pageCount)}
        onPageChange={(e) => handlePageClick(e)}
        containerClassName={
          "pagination flex flex-row text-primary-off-black dark:text-primary-off-white justify-end my-0 pb-1 mx-8 transition duration-300"
        }
        pageClassName={"mx-4"}
        activeClassName={
          "active border border-primary-off-black dark:border-primary-off-white text-primary-off-black dark:text-primary-off-white rounded-full px-2 transition duration-300"
        }
        forcePage={initialPage}
      />
    </div>
  );
};

export default Pagination;
